import React, { useState } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import { useSelector } from 'react-redux';

const Accordion2 = props => {
  const selectedOrgs = useSelector(state => state.selectedOrganisations);

  const toSentenceCase = camelCase => {
    if (camelCase.includes('ID')) {
      return camelCase;
    }
    if (camelCase) {
      const result = camelCase.replace(/([A-Z])/g, ' $1').trim();
      return result[0].toUpperCase() + result.substring(1).toLowerCase();
    }
    return '';
  };

  return (
    <div className={styles.accordionDetails}>
      {[...new Set(selectedOrgs?.selectedOrganisations?.map(c => c.category))]?.map(c => (
        <div className={styles.orgSection}>
          <h3 className={styles.sectionTitle}>{c}</h3>
          <div className={``}>
            {selectedOrgs.selectedOrganisations
              .filter(x => x.category === c)
              .map(z => (
                <div className={`${styles.orgName} d-flex  flex-wrap align-items-center`}>
                  <img src={z.logo} alt="logo" />
                  <div className={styles.name} translate="no">
                    {' '}
                    {z.label}{' '}
                  </div>
                  {z.policyNumber[0] !== '' ? (
                    <div className={styles.policyNumber}>
                      {z?.policyNumber?.map(p => (
                        <div className={styles.additionalInfoValue}>
                          {toSentenceCase(
                            JSON.parse(
                              z.orgReferenceList
                            ).OrganisationFieldDetails[0].fieldName.trim()
                          )}
                          : {p}
                        </div>
                      ))}
                    </div>
                  ) : null}
                  {}
                  <div className={styles.editExtraLink}>
                    {z?.policyNumber.length > 0 ? (
                      <a
                        onClick={() => {
                          props.history.push('/select-orgs?id=2');
                        }}
                        onKeyPress={event => {
                          if (event.key === 'Enter') {
                            props.history.push('/select-orgs?id=2');
                          }
                        }}
                        tabIndex="0"
                        href="javascript:void(0)"
                      >
                        Edit details
                      </a>
                    ) : null}
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
      <a
        onKeyPress={event => {
          if (event.key === 'Enter') {
            props.history.push('/select-orgs');
          }
        }}
        tabIndex="0"
        href="javascript:void(0)"
        className={`${styles.editLink} mt-5`}
        onClick={() => {
          props.history.push('/select-orgs');
        }}
      >
        Edit organisations
      </a>
    </div>
  );
};

export default Accordion2;
